import React, { useState } from 'react';
import { Calendar } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { AiOutlineCloseCircle } from 'react-icons/ai';
import '@/app/globals.css';

interface DatePickerProps {
    selectedDate?: Date;
    onChange: (date: Date | null) => void;
    disabledDates?: Date[];
    availableDates?: Date[];
    maxParticipants?: number;
    availableDatesInfo?: { date: Date; maxParticipants: number }[];
}

const DatePicker: React.FC<DatePickerProps> = ({
    selectedDate,
    onChange,
    disabledDates,
    availableDates,
    maxParticipants,
    availableDatesInfo,
}) => {
    const handleDateChange = (date: Date) => {
        onChange(date);
    };

    const clearDate = () => {
        onChange(null);
    };

    const renderDayContent = (date: Date) => {
        const availableDateInfo = availableDatesInfo?.find(
            (d) => new Date(d.date).toDateString() === date.toDateString()
        );

        const isAvailableDate = availableDates?.some(
            (d) => d.toDateString() === date.toDateString()
        );

        const isDisableDate = disabledDates?.some(
            (d) => d.toDateString() === date.toDateString()
        );

        const isPastDate = date < new Date();

        let dayStyle: React.CSSProperties = {
            color: disabledDates ? 'gray' : 'black',
        };

        let indicatorStyle: React.CSSProperties = {};

        // if (isClosedDate) {
        //     dayStyle = {
        //         ...dayStyle,
        //         color: '#dc2626',
        //         fontWeight: 'bold',
        //     };
        // } else 

        if (isAvailableDate && !isPastDate && !isDisableDate) {
            dayStyle = {
                ...dayStyle,
                // color: '#eab308',
                color: 'black',
                fontWeight: 'bold',
                marginTop: '12px',
                marginBottom: '12px',
            };
            indicatorStyle = {
                width: '24px',
                height: '24px',
                borderRadius: '50%',
                background: '#fde047',
                position: 'absolute',
                bottom: '-1px',
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#000',
                fontWeight: 'normal',
                fontSize: '12px',
            };
            maxParticipants = availableDateInfo?.maxParticipants;
        }

        return (
            <div style={{ position: 'relative' }}>
                <div style={dayStyle}>{date.getDate()}</div>
            </div>
        );
    };

    return (
        <div className="flex flex-col items-center">
            <Calendar
                color={'#0891b2'}
                date={selectedDate}
                weekStartsOn={1}
                className="text-md"
                onChange={(date) => handleDateChange(date as Date)}
                minDate={new Date()}
                dayContentRenderer={(date) => renderDayContent(date as Date)}
            />
            {selectedDate && (
                <div style={{ textAlign: 'center', marginTop: '5px' }}>
                    <button className="border rounded-lg border-cyan-700 p-2" onClick={clearDate}>Clear Date</button>
                </div>
            )}
        </div>

    );
};

export default DatePicker;
